export const BadgeSize = {
  Big: 'big',
  Medium: 'medium',
  Small: 'small',
}

export const BadgeVariant = {
  Error: 'error',
  Theme: 'theme',
}
